import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import NavigationHeader from "@/components/NavigationHeader";
import HeroSection from "@/components/HeroSection";
import EditorialMarquee from "@/components/EditorialMarquee";
import ArchivalTeaserGrid from "@/components/ArchivalTeaserGrid";
import ManifestoChapters from "@/components/ManifestoChapters";
import CollectorVaultModal from "@/components/CollectorVaultModal";
import FooterSection from "@/components/FooterSection";

function App() {
  const [vaultOpen, setVaultOpen] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 0.95 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain relative min-h-screen bg-[#FAF6F0]" data-testid="oldengoods-app">
      <NavigationHeader onRequestInvite={() => setVaultOpen(true)} />
      <main>
        <HeroSection onRequestInvite={() => setVaultOpen(true)} />
        <EditorialMarquee />
        <ArchivalTeaserGrid />
        <ManifestoChapters />
      </main>
      <FooterSection onRequestInvite={() => setVaultOpen(true)} />
      <CollectorVaultModal open={vaultOpen} onClose={() => setVaultOpen(false)} />
      <Toaster position="bottom-right" toastOptions={{
        style: { background: "#171412", color: "#FAF6F0", border: "1px solid #C59B27", borderRadius: "2px", fontFamily: "'IBM Plex Mono', monospace", fontSize: "12px" },
      }} />
    </div>
  );
}

export default App;
